<script
    src="../../../../../../../AppData/Local/Temp/Rar$DRa14036.14120/src/app/helper/alertTimer/alert-timer.service.ts"
></script>
<template>
  <!-- The Modal -->
  <div
    id="editModal"
    class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            title="Edit Representative"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="representative_id">Representative</label>
                      <validation-provider
                        #default="{ errors }"
                        name="representative_id"
                        rules=""
                      >
                        <v-select
                          v-model="assignedRepresentative.representative_id"
                          name="representative_id"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="representatives"
                          :reduce="full_name => full_name.id"
                          label="full_name"
                          :disabled="true"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="projects">Projects</label>
                      <validation-provider
                        #default="{ errors }"
                        name="projects"
                        rules="required"
                      >
                        <v-select
                          v-model="projectsTemp"
                          name="projects"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="projects"
                          :reduce="name => name.id"
                          label="name"
                          multiple
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    id="assignRepresintativeButton"
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormTextarea,

} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import FormTextAreaDefault from '../../../../shared/form-textarea/FormTextAreaDefault.vue'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import RepresentativesService from '@/services/representativesService'
import clientService from '../../../../services/clientService'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BFormTextarea,
    FormTextAreaDefault,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['representative'],
  data() {
    return {
      projectsTemp: [],
      representatives: [],
      projects: [],
      assignedRepresentative: {
        id: '',
        representative_id: '',
        projects: [],
      },
      titles: ['Mr.', 'Ms.'],
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        maxFiles: 1,
      },
      edited_service: {
        name: '',
        description: ''
      },
      codeBasic,
      selected: '',
    }
  },
  mounted() {
    this.getClientRepresintatives()
    this.getProjects()
    this.$watch(() => this.representative, representative => {
      console.log('representative :: ', representative)
      // const projects = representative.projects.map(el => el.name)
      this.projectsTemp = representative.projects
      this.assignedRepresentative.id = representative.id
      this.assignedRepresentative.representative_id = representative.full_name
      console.log('projectsTemp', this.projectsTemp)
      // this.assignedRepresentative.projects = projects

    })
    // this.$watch(() => this.representatives, SelectTwoRepresentatives => {
    //   console.log('rSelectTwoRepresentatives :: ', SelectTwoRepresentatives.length)
    //   if(SelectTwoRepresentatives.length === 0){
    //
    //     document.getElementById('assignRepresintativeButton').disabled = true
    //     document.getElementById('assignRepresintativeButton').style.cursor = 'not-allowed'
    //   }
    //   else{
    //     document.getElementById('assignRepresintativeButton').disabled = false;
    //     document.getElementById('assignRepresintativeButton').style.cursor = 'pointer'
    //
    //   }
    // })
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate()
          .then(success => {
            if (success) {
              this.assignedRepresentative.id = this.$route.params.id
              this.assignedRepresentative.representative_id= this.representative.id
              this.assignedRepresentative.projects = this.projectsTemp
              // this.assignedRepresentative.projects = this.projectsTemp.map(el => el.id)

                  console.log('repo :: ', this.assignedRepresentative )

              clientService.editAssignedReprsentative(this.$route.params.id, this.assignedRepresentative)
                  .then(response => {
                    this.$emit('refresh', 'true')
                    this.assignedRepresentative= {
                      id: '',
                      representative_id: '',
                      projects: [],
                    },

                        $('#editModal') .modal('hide')
                    if(response && response.status === 200){
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: 'Success',
                          icon: 'CheckIcon',
                          variant: 'success',
                          text: `Projects Is Assigned Successfully !`,
                        },
                      })
                    }

                    this.loading = false
                    console.log('testing')
                  })
            }})
          .catch(
              function (error) {
                console.log('Show error notification!', error)
                $('#editModal').modal('hide')
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'Error',
                    text: `Error !`,
                  },
                })
                return Promise.reject(error)
              }
          )
    },
    resetDropzone(){
      this.$refs.createRef.removeAllFiles()

    },
    getClientRepresintatives(){
      console.log('llll', this.$router)
      clientService.clientRepresintatives(this.$route.params.id).then(response => {
        this.representatives = response.data.data
        this.loading = false
      })
    },
    getProjects(){
      clientService.clientProjects(this.$route.params.id).then(response => {
        this.projects = response.data.data
        console.log('projects ::', this.projects)
        this.loading = false
      })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

label {
  font-weight: bold;
}
</style>
